/**
 * Size Guide Popup JavaScript
 * Handles modal open/close and CM/IN unit conversion
 */
class SizeGuidePopup {
  constructor() {
    this.modal = null;
    this.triggers = [];
    this.currentUnit = 'cm';
    this.conversionFactor = 2.54; // Default
    
    this.init();
  }
  init() {
    // Find all size guide triggers
    this.triggers = document.querySelectorAll('[data-size-guide-trigger]');
    
    // Find the modal
    this.modal = document.querySelector('[data-size-guide-modal]');
    
    if (!this.modal) return;

    // Read conversion factor from table if present
    const tbody = this.modal.querySelector('tbody[data-conversion-factor]');
    if (tbody) {
      this.conversionFactor = parseFloat(tbody.getAttribute('data-conversion-factor')) || 2.54;
    }
    
    // Move modal to body to avoid positioning issues with parent containers
    if (this.modal.parentElement !== document.body) {
      document.body.appendChild(this.modal);
    }
    
    // Bind events
    this.bindEvents();
  }
  bindEvents() {
    // Open modal on trigger click
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.open());
    });
    // Close modal on close button or overlay click
    const closeButtons = this.modal.querySelectorAll('[data-size-guide-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
    // Unit toggle
    const unitButtons = this.modal.querySelectorAll('[data-unit]');
    unitButtons.forEach(button => {
      button.addEventListener('click', () => {
        const unit = button.getAttribute('data-unit');
        this.switchUnit(unit);
      });
    });
  }
  open() {
    this.modal.classList.add('active');
    document.body.classList.add('size-guide-modal-open');
    
    // Focus trap
    const firstFocusable = this.modal.querySelector('button');
    if (firstFocusable) {
      setTimeout(() => firstFocusable.focus(), 100);
    }
  }
  close() {
    this.modal.classList.remove('active');
    document.body.classList.remove('size-guide-modal-open');
  }
  switchUnit(unit) {
    if (this.currentUnit === unit) return;
    
    this.currentUnit = unit;
    
    // Update button states
    const unitButtons = this.modal.querySelectorAll('[data-unit]');
    unitButtons.forEach(button => {
      const isActive = button.getAttribute('data-unit') === unit;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive);
    });
    // Convert table values
    this.convertTableValues(unit);
  }
  convertTableValues(unit) {
    const table = this.modal.querySelector('.size-guide-table');
    if (!table) return;
    const cells = table.querySelectorAll('td[data-cm]');
    
    cells.forEach(cell => {
      const cmValue = parseFloat(cell.getAttribute('data-cm'));
      
      if (unit === 'in') {
        // Convert CM to Inches
        const inchValue = cmValue / this.conversionFactor;
        cell.textContent = inchValue.toFixed(1);
      } else {
        // Show CM value
        cell.textContent = cmValue;
      }
    });
  }
}
// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SizeGuidePopup();
  });
} else {
  new SizeGuidePopup();
}